var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlideTalk1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 86.601,
    viewBox: "0 0 149 86.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1681",
    "data-name": "Group 1681",
    transform: "translate(-327.035 -536.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3978",
    "data-name": "Rectangle 3978",
    width: 149,
    height: 73.843,
    rx: 8,
    transform: "translate(327.035 536.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_762",
    "data-name": "Ellipse 762",
    cx: 2.279,
    cy: 2.279,
    rx: 2.279,
    ry: 2.279,
    transform: "translate(327.035 618.353)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_763",
    "data-name": "Ellipse 763",
    cx: 3.419,
    cy: 3.419,
    rx: 3.419,
    ry: 3.419,
    transform: "translate(333.872 612.655)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlideTalk1);
export default __webpack_public_path__ + "static/media/glide_talk_1.d3e47f4b.svg";
export { ForwardRef as ReactComponent };